export class DateManipulationModel {
  constructor(public target = '', public source = '', public func = 'ADD', public interval = 1, public part = 'YEAR') {}
}
